import { render, staticRenderFns } from "./MultiSelectApproval.vue?vue&type=template&id=7b932666"
import script from "./MultiSelectApproval.vue?vue&type=script&lang=js"
export * from "./MultiSelectApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports